<template>
  <el-dialog
    :title="$t('newOaWorkflowUndo.cancelTitle')"
    :visible.sync="visible"
    width="30%"
    @close="handleClose"
  >
    <div class="text-center">
      <p>{{ $t('newOaWorkflowUndo.cancelConfirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { cancelOaWorkflowInstance } from '@/api/oa/newOaWorkflowDetailApi'

export default {
  name: 'CancelOaWorkflowInstance',
  data() {
    return {
      visible: false,
      form: {
        id: '',
        flowId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.form = {
        id: data.id,
        flowId: data.flowId
      }
      this.visible = true
    },
    handleClose() {
      this.form = {
        id: '',
        flowId: ''
      }
    },
    async handleConfirm() {
      try {
        await cancelOaWorkflowInstance(this.form)
        this.$message.success(this.$t('newOaWorkflowUndo.cancelSuccess'))
        this.visible = false
        this.$emit('success')
      } catch (error) {
        console.error('取消流程失败:', error)
        this.$message.error(this.$t('newOaWorkflowUndo.cancelError'))
      }
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}
</style>
